// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentName = function (x) {
    return x;
};
var tsBridgeDocumentName = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentName")("__brandDocumentName"));
    }
};
var writeDocumentName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentName = Data_Show.showString;
var readDocumentName = Simple_JSON.readString;
var ordDocumentName = Data_Ord.ordString;
var newtypeDocumentName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentName = DocumentName;
var hasRuntimeTypeDocumentName = Untagged_TypeCheck.hasRuntimeTypeString;
var eqDocumentName = Data_Eq.eqString;
export {
    DocumentName,
    makeDocumentName,
    unwrap,
    newtypeDocumentName,
    eqDocumentName,
    ordDocumentName,
    showDocumentName,
    readDocumentName,
    writeDocumentName,
    hasRuntimeTypeDocumentName,
    tsBridgeDocumentName
};
//# sourceMappingURL=index.js.map
